// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__3K5Cu","header":"MergedInvoice_header__2OPTo"};